import React from 'react'
import {connect} from "react-redux";

// components
import {GenericButton} from "./customButtons";
import {ConfirmAlert} from "../confirmAlert/ConfirmAlert";

// actios
import {genericIndexedActions} from "../../redux/actions/generics/GenericIndexedActions";
import {genericActions} from "../../redux/actions/generics/GenericActions";

const RemoveFormFirebaseButton = props => {
    const { id, fbDataBase, path= null, service } = props

    const handleClick = () => ConfirmAlert({
        path,
        service,
        remove : path != null ? genericIndexedActions.removeFromFirebase : genericActions.removeFromFirebase,
        data : {
            fbDataBase:{ id: fbDataBase },
            item:{
                id
            }
        },
    })

    return <GenericButton
        style={ 'danger-secondary' }
        toolTip={'Remover de firebase'}
        icon={'fa-eraser'}
        permission={'search'}
        onClick={handleClick}
    />
}

const mapStateToProps = state => ({ mainProps : state.mainProps })
const mapActionsToProps = ({})

export default connect(mapStateToProps, mapActionsToProps)(RemoveFormFirebaseButton)